const htmlEntities: { [char: string]: string } = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;'
}

/**
 * Encodes a visitor's value for an e-mail HTML body (the server rejects mail bodies with other markup than <br>)
 */
export function htmlEncode(text: string) {
	return (text || '').replace(/[&<>"']/g, char => htmlEntities[char])
}
